import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { KeyValuePairEnum } from '../../models/key-value-pair-enum';
import { CFDocumentStoreService } from './cf-document-store.service';
import { CFDocumentService } from './cf-document.service';

@Injectable({ providedIn: 'root' })
export class CFDocumentTypesResolver implements Resolve<Array<KeyValuePairEnum>> {
    constructor(
        private documentService: CFDocumentService,
        private documentStoreService: CFDocumentStoreService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Array<KeyValuePairEnum>> | Promise<Array<KeyValuePairEnum>> | Array<KeyValuePairEnum> {
        return new Promise((resolve, reject) => {
            this.documentService.getDocumentTypes().subscribe((documentTypes: Array<KeyValuePairEnum>) => {
                this.documentStoreService.setDocumentTypes(documentTypes);
                resolve(documentTypes);
            });
        });
    }
}
